import React from 'react'

import { useDynamicViewContext } from '../context'
import { PivotColumn } from './PivotTable'
import { PIVOT_LABEL_COLUMN_WIDTH, PivotBodyRow, PivotHeaderCell } from './PivotTable.styles'

interface Props {
  pivotColumns: PivotColumn[]
  hoveredColumnId: string | undefined
  setHoveredColumnId: (value: string | undefined) => void
}

export function PivotTableHeader({ pivotColumns, hoveredColumnId, setHoveredColumnId }: Props) {
  const { styleMode, pinned, onRowClick } = useDynamicViewContext()

  const mode = styleMode ?? 'Default'

  return (
    <PivotBodyRow>
      <PivotHeaderCell
        $visible={true}
        scope="col"
        size="small"
        styleMode={mode}
        $first={true}
        $pinned={pinned}
        $width={PIVOT_LABEL_COLUMN_WIDTH}
      />

      {pivotColumns.map((column) => (
        <PivotHeaderCell
          $visible={true}
          key={column.id}
          scope="col"
          size="small"
          styleMode={mode}
          $highlighted={hoveredColumnId === column.id}
          $clickable={!!onRowClick}
          onMouseEnter={() => setHoveredColumnId(column.id)}
          onMouseLeave={() => setHoveredColumnId(undefined)}
          onClick={() => onRowClick?.(column.entity)}
        >
          {column.label}
        </PivotHeaderCell>
      ))}
    </PivotBodyRow>
  )
}
